/**
 * @file schemas/materials.ts
 * @description 資材庫（農藥/肥料等可用物質）Zod 校驗 schema。
 */
import { z } from 'zod';
/**
 * 建立資材請求 schema。
 * ingredients / approvedSchemes 為 JSONB 欄位，P0 接受任意 JSON。
 */
export const createMaterialSchema = z.object({
    /** 分類（pesticide / fertilizer / additive …） */
    category: z.string().min(1).max(50),
    /** 資材名稱 */
    name: z.string().min(1).max(200),
    /** 成份（結構化 JSON；P0 可為空） */
    ingredients: z.unknown().optional(),
    /** 核可的驗證方案列表（JSON 陣列；P0 可為任意 JSON） */
    approvedSchemes: z.unknown().optional(),
    /** 備注說明 */
    notes: z.string().optional(),
    /** 是否啟用（預設 true） */
    isActive: z.boolean().optional(),
});
/**
 * 更新資材請求 schema（所有欄位可選）。
 */
export const updateMaterialSchema = createMaterialSchema.partial();
